{
  "title": "Mending",
  "source": "Player's Handbook",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V, S, M (two lodestones)",
  "duration": "Instantaneous",
  "description": [
    "This spell repairs a single break or tear in an object you touch, such as a broken chain link, two halves of a broken key, a torn cloak, or a leaking wineskin. As long as the break or tear is no larger than 1 foot in any dimension, you mend it, leaving no trace of the former damage.",
    "This spell can physically repair a magic item or construct, but the spell can’t restore magic to such an object."
  ],
  "spellLists": [
    "artificer",
    "bard",
    "cleric",
    "druid",
    "eldritch-knight",
    "arcane-trickster",
    "sorcerer",
    "wizard"
  ]
}
